import { render, staticRenderFns } from "./HeroImage.vue?vue&type=template&id=da71b030&scoped=true&"
import script from "./HeroImage.vue?vue&type=script&lang=js&"
export * from "./HeroImage.vue?vue&type=script&lang=js&"
import style0 from "./HeroImage.vue?vue&type=style&index=0&id=da71b030&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da71b030",
  null
  
)

export default component.exports